import { apiSlice } from "./apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Leaderboard"],
});

const leaderboardApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getMyLeaderboardStats: builder.query({
      query: () => "/leaderboard/me",
      providesTags: ["Leaderboard"],
    }),
    getWeeklyLeaderboard: builder.query({
      query: (cursor = {}) => {
        const params = new URLSearchParams({ per_page: 10 });
        if (cursor.after_points != null) params.set("after_points", cursor.after_points);
        if (cursor.after_id != null) params.set("after_id", cursor.after_id);
        return `/leaderboard?${params.toString()}`;
      },
      providesTags: ["Leaderboard"],
    }),
    getStudentOverviewStats: builder.query({
      query: () => "/student/overview-stats",
      providesTags: ["Leaderboard"],
    }),
    getClassroomQuizLeaderboard: builder.query({
      query: (classroomId) => `/leaderboard/classroom/${classroomId}`,
      providesTags: ["Leaderboard"],
    }),
    getClassroomAcademicRanking: builder.query({
      query: ({ classroomId, termId }) => {
        const params = new URLSearchParams({ classroom_id: classroomId });
        if (termId) params.set("term_id", termId);
        return `/record/classroom-ranking?${params.toString()}`;
      },
      providesTags: ["Leaderboard"],
    }),
    getParentLeaderboard: builder.query({
      query: (studentId) => `/parent/leaderboard/${studentId}`,
      providesTags: ["Leaderboard"],
    }),
  }),
});

export const {
  useGetMyLeaderboardStatsQuery,
  useGetWeeklyLeaderboardQuery,
  useGetStudentOverviewStatsQuery,
  useGetClassroomQuizLeaderboardQuery,
  useGetClassroomAcademicRankingQuery,
  useGetParentLeaderboardQuery,
} = leaderboardApiSlice;

export default leaderboardApiSlice;

